import { registerQuery, useQuery } from 'data-fetching-client';
import { crmSearch } from '../api/crm-search';
import { INTERACTIVE_OBJECT_TYPE_ID } from '../constants/properties';
import { PROPERTIES_TO_CRM } from '../constants/properties';
const SMART_CTA_QUERY = registerQuery({
  fieldName: 'crmSearchSmartCta',
  args: ['interactiveId'],
  fetcher({
    interactiveId
  }) {
    return crmSearch({
      objectTypeId: INTERACTIVE_OBJECT_TYPE_ID,
      count: 1,
      requestOptions: {
        properties: [PROPERTIES_TO_CRM.IS_SMART]
      },
      filterGroups: [{
        filters: [{
          property: PROPERTIES_TO_CRM.CONTENT_ID,
          value: interactiveId,
          operator: 'EQ'
        }]
      }]
    });
  }
});
const useIsSmartCta = interactiveId => {
  var _data$crmSearchSmartC;
  const {
    data,
    loading: isLoading,
    error
  } = useQuery(SMART_CTA_QUERY, {
    variables: {
      interactiveId
    }
  });
  const isSmartCta = !isLoading && !error && (data === null || data === void 0 || (_data$crmSearchSmartC = data.crmSearchSmartCta) === null || _data$crmSearchSmartC === void 0 || (_data$crmSearchSmartC = _data$crmSearchSmartC.results) === null || _data$crmSearchSmartC === void 0 || (_data$crmSearchSmartC = _data$crmSearchSmartC[0]) === null || _data$crmSearchSmartC === void 0 || (_data$crmSearchSmartC = _data$crmSearchSmartC.properties) === null || _data$crmSearchSmartC === void 0 || (_data$crmSearchSmartC = _data$crmSearchSmartC.hs_is_smart_cta) === null || _data$crmSearchSmartC === void 0 ? void 0 : _data$crmSearchSmartC.value) === 'true';
  return {
    isSmartCta,
    isLoading,
    error
  };
};
export default useIsSmartCta;